module.exports = __webpack_public_path__ + "static/media/teaching_server_icon_1.0ef14682.svg";